import type { ChartPanel } from 'features/charts-v2/types/filter-hash/v2'
import {
  isYogiQLStoredPanel,
  type StoredPanel,
  YOGIQL_QUERY_FIELDS,
  type YogiQLStoredPanel,
} from 'features/charts-v2/types/stored-panel'
import type { ChartRequest } from 'features/charts-v2/types/yogiql'
import type { ChartsPageState } from 'features/charts-v2/types/yogiql-page-state'

// The charts page's defaults, as `buildChartsV2State` writes them.
const GLOBAL_SETTINGS: ChartsPageState['globalSettings'] = {
  syncYAxis: true,
  syncXAxis: true,
  syncDisplaySettings: false,
}

/** A link panel in the stored YogiQL form: its display fields, and the request
 *  the chat drew in place of the query fields decoded from it. */
export function storedLinkPanel(
  panel: ChartPanel,
  request: ChartRequest,
): YogiQLStoredPanel {
  const display: Record<string, unknown> = { ...panel }
  for (const key of YOGIQL_QUERY_FIELDS) delete display[key]
  return { ...(display as Omit<YogiQLStoredPanel, 'request'>), request }
}

/** A chat chart's "View in charts" panels as the charts page's state, each
 *  panel's request named `query` as the route takes it; null when one is not
 *  in the stored YogiQL form (that link keeps the legacy hash). */
export function chartsLinkState(
  panels: StoredPanel[],
  activePanelId: string | undefined,
): ChartsPageState | null {
  if (panels.length === 0 || !panels.every(isYogiQLStoredPanel)) return null
  return {
    panels: panels.map(({ request, ...panel }) => ({
      ...panel,
      query: request,
    })),
    globalSettings: GLOBAL_SETTINGS,
    activePanelId: activePanelId ?? panels[0]!.id,
  }
}
